import script from "./CreateSchemeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateSchemeModal.vue?vue&type=script&setup=true&lang=js"

import "./CreateSchemeModal.vue?vue&type=style&index=0&id=3dadcf00&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dadcf00"]])

export default __exports__